class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('mouseover', this.onMouseover.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
   // this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
     // this.close(true);
       this.getSearchResults('tag:search_suggestion');
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
     // this.closeResults(true);
    }
  }

  onFocus() {
  
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) {
         this.getSearchResults('tag:search_suggestion');
        return;
     }

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
     // if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseover(){
     if (this.searchTerm.length == 0){
         this.getSearchResults('tag:search_suggestion');
     };
  }


  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    document.getElementById("search__button_c").click();
    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const sectionUrl = (term) =>
      `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search`;

    // Products rank poorly for bare partial terms, so the product row is fetched with a
    // trailing wildcard. Suggestions and collections stay on the bare term, which the
    // wildcard makes noisier. Field-scoped terms (tag:search_suggestion) are left alone.
    const widenedTerm = searchTerm.includes(':') || searchTerm.endsWith('*') ? null : `${searchTerm}*`;

    const bareRequest = fetch(sectionUrl(searchTerm), {
      signal: this.abortController.signal,
    }).then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    });

    // Best-effort only: if it fails, the bare product results are kept.
    const widenedRequest = widenedTerm
      ? fetch(sectionUrl(widenedTerm), { signal: this.abortController.signal })
          .then((response) => (response.ok ? response.text() : null))
          .catch(() => null)
      : Promise.resolve(null);

    Promise.all([bareRequest, widenedRequest])
      .then(([text, widenedText]) => {
        const parser = new DOMParser();
        const section = parser.parseFromString(text, 'text/html');

        if (widenedText) {
          const widenedProducts = parser
            .parseFromString(widenedText, 'text/html')
            .querySelector('#predictive-search-results-products-list');
          const products = section.querySelector('#predictive-search-results-products-list');

          if (widenedProducts && products) {
            // Shopify stamps the fetched term onto every result link as _psq, which feeds
            // search analytics. Put the customer's own term back so the wildcard stays internal.
            widenedProducts.querySelectorAll('a[href*="_psq="]').forEach((link) => {
              link.setAttribute(
                'href',
                link.getAttribute('href').replace(/([?&]_psq=)[^&]*/, `$1${encodeURIComponent(searchTerm)}`)
              );
            });
            products.innerHTML = widenedProducts.innerHTML;
          }
        }

        const resultsMarkup = section.querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);

    
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
     this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      document.getElementById('paspop-search').style.display="block";
         document.getElementById('suggestions').innerHTML="";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

/**slider**/


 function clickPrevSlider () {
const slider = document.getElementById("data-slider");
const track = document.getElementById("predictive-search-results-products-list");
const prev = document.getElementById("data-slider-prev");
const next = document.getElementById("data-slider-next");

    next.removeAttribute("disabled");
  
    track.scrollTo({
      left: track.scrollLeft - track.firstElementChild.offsetWidth,
      behavior: "smooth"
    });
    track.addEventListener("scroll", () => {
    const trackScrollWidth = track.scrollWidth;
    const trackOuterWidth = track.clientWidth;

    prev.removeAttribute("disabled");
    next.removeAttribute("disabled");

    if (track.scrollLeft <= 0) {
      prev.setAttribute("disabled", "");
    }

    if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
      next.setAttribute("disabled", "");
    }
  });
  }


 function clickNextSlider () {

    const slider = document.getElementById("data-slider");

const track = document.getElementById("predictive-search-results-products-list");
const prev = document.getElementById("data-slider-prev");
const next = document.getElementById("data-slider-next");
    prev.removeAttribute("disabled");
 
    track.scrollTo({
      left: track.scrollLeft + track.firstElementChild.offsetWidth,
      behavior: "smooth"
    });
    track.addEventListener("scroll", () => {
    const trackScrollWidth = track.scrollWidth;
    const trackOuterWidth = track.clientWidth;

    prev.removeAttribute("disabled");
    next.removeAttribute("disabled");

    if (track.scrollLeft <= 0) {
      prev.setAttribute("disabled", "");
    }

    if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
      next.setAttribute("disabled", "");
    }
  });
  }



(function () {
  const input = document.getElementById('Search-In-Modal');
  const header = document.querySelector('.predictive-search--header');
  const suggestions = document.getElementById('suggestions');
  let seeAllLink = null;

  if (!input || !header || !suggestions) return;

  const updateSeeAllLink = () => {
    const query = input.value.trim();
    const hasSuggestions = suggestions.children.length > 0;

    if (query.length > 0 && !hasSuggestions) {
      const encodedQuery = encodeURIComponent(query);

      if (!seeAllLink) {
        seeAllLink = document.createElement('a');
        seeAllLink.textContent = 'See all results';
        seeAllLink.target = '_blank';
        seeAllLink.classList.add('see-all-results-link');
        Object.assign(seeAllLink.style, {
          marginTop: '10px',
          display: 'block',
          fontWeight: '500',
          color: '#000',
          textAlign: 'left',
          padding: '3px'
        });

        header.insertAdjacentElement('afterend', seeAllLink);
      }

      seeAllLink.href = `https://www.rjliving.com.au/search?q=${encodedQuery}&options%5Bprefix%5D=last`;
    } else {
      if (seeAllLink) {
        seeAllLink.remove();
        seeAllLink = null;
      }
    }
  };

  input.addEventListener('input', updateSeeAllLink);

  const observer = new MutationObserver(updateSeeAllLink);
  observer.observe(suggestions, { childList: true, subtree: true });
})();



